import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Redirect } from "react-router-dom";
import { dashboardLayoutRoutes, authLayoutRoutes } from "./index";
import { hasActiveSession } from "../utils/sessionAuth";

import DashboardLayout from "../layouts/Dashboard";
import AuthLayout from "../layouts/Auth";

const childRoutes = (Layout, routes) =>
  routes.map(({ component: Component, guard, children, path }, index) => {
    const Guard = guard || React.Fragment;

    return children ? (
      children.map((element, index) => {
        const Guard = element.guard || React.Fragment;
        const ElementComponent = element.component || React.Fragment;

        return (
          <Route
            key={index}
            path={element.path}
            exact
            render={(props) =>
              hasActiveSession() ? (
                <Layout>
                  <Guard>
                    <ElementComponent {...props} />
                  </Guard>
                </Layout>
              ) : element.path === "/auth/sign-in" ||
                element.path === "/auth/sign-up" ||
                element.path === "/auth/social/complete-registration" ||
                element.path === "/auth/reset-password" ||
                element.path === "/forgotPasswordLast/:id" ||
                element.path === "/emailConfirmation/:id" ? (
                <Layout>
                  <Guard>
                    <ElementComponent {...props} />
                  </Guard>
                </Layout>
              ) : (
                <Redirect to="/auth/sign-in" />
              )
            }
          ></Route>
        );
      })
    ) : Component ? (
      <Route
        key={index}
        path={path}
        exact
        render={(props) =>
          hasActiveSession() ? (
            <Layout>
              <Guard>
                <Component {...props} />
              </Guard>
            </Layout>
          ) : (
            <Redirect to="/auth/sign-in" />
          )
        }
      ></Route>
    ) : null;
  });

const Routes = () => (
  <Router>
    <Switch>
      <Route exact path="/">
        {hasActiveSession() ? (
          <Redirect to="/dashboard" />
        ) : (
          <Redirect to="/auth/sign-in" />
        )}
      </Route>

      {childRoutes(DashboardLayout, dashboardLayoutRoutes)}
      {/* {childRoutes(DashboardLayout, CreateAdCampaign)} */}
      {childRoutes(AuthLayout, authLayoutRoutes)}
      <Route>
        <Redirect to={hasActiveSession() ? "/auth/404" : "/auth/sign-in"} />
      </Route>
    </Switch>
  </Router>
);

export default Routes;
